<template>
    <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on:dialog }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on:tooltip }">
                    <v-btn color="blue"
                           dark
                           :small="$vuetify.breakpoint.mdAndDown"
                           :fab="$vuetify.breakpoint.mdAndDown"
                           v-on="{...dialog, ...tooltip}"
                    >
                        <v-icon :left="$vuetify.breakpoint.lgAndUp">mdi-plus</v-icon>
                        <span class="d-none d-lg-block">Новый вид абонемента</span>
                    </v-btn>
                </template>
                <span>Добавить новый вид абонемента</span>
            </v-tooltip>
        </template>
        <v-card class="modal-card">
            <v-card-title class="pa-6">Новый вид абонемента</v-card-title>
            <v-card-text class="pa-6">
                <ValidationObserver ref="form" v-slot="{ passes }" tag="div">
                    <v-form @submit.prevent="passes(save)">
                        <v-row>
                            <v-col cols="12" class="pb-0">
                                <ValidationProvider name="name"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                    tag="div"
                                                    class="client-info-group">
                                    <v-text-field
                                            type="text"
                                            v-model="name"
                                            label="Название абонемента"
                                            outlined
                                            :error-messages="errors"
                                    />
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="7" sm="8" class="pb-0">
                                <ValidationProvider name="duration"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                    tag="div"
                                                    class="client-info-group">
                                    <v-text-field
                                            type="number"
                                            v-model="duration"
                                            :label="durationLabel"
                                            outlined
                                            :error-messages="errors"
                                    />
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="5" sm="4" class="pb-0">
                                <ValidationProvider name="duration_unit"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                    tag="div"
                                                    class="client-info-group">
                                    <v-select
                                            v-model="duration_unit"
                                            :items="[{title:'Месяц', value: 'month'}, {title:'День', value: 'day'}]"
                                            item-text="title"
                                            item-value="value"
                                            outlined
                                            :error-messages="errors"
                                    />
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="pb-0">
                                <ValidationProvider name="visits_limit"
                                                    v-slot="{ errors }"
                                                    tag="div"
                                                    class="client-info-group">
                                    <v-text-field
                                            type="number"
                                            v-model="visits_limit"
                                            label="Количество посещений"
                                            outlined
                                            hint=" Оставить пустым если нет лимита"
                                            persistent-hint
                                            :error-messages="errors"
                                    />
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                    </v-form>
                </ValidationObserver>
            </v-card-text>
            <v-card-actions class="px-6 py-5">
                <v-spacer></v-spacer>
                <v-btn depressed dark color="blue-grey" @click="close" min-width="120" class="mx-2">Закрыть
                </v-btn>
                <v-btn depressed color="success" @click="save" min-width="120">Создать</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import cardTypesApi from '../api/card-type.api';

    export default {
        name    : "CardTypeCreateDialog",
        data() {
            return {
                dialog: false,

                name         : '',
                duration     : '',
                duration_unit: 'month',
                visits_limit : '',
            }
        },
        computed: {
            durationLabel() {
                return 'Количество ' + (this.duration_unit === 'month' ? 'месяцев' : 'дней');
            }
        },
        methods : {
            async save() {
                if (false === await this.$refs.form.validate()) {
                    return;
                }

                this.$store.commit('setLoading', true);

                cardTypesApi.create({
                    name         : this.name,
                    duration     : this.duration,
                    duration_unit: this.duration_unit,
                    visits_limit : this.visits_limit,
                }).then(({data}) => {
                    this.$store.commit('card-types/ADD_ITEM', data.data);
                    this.close();
                }).catch(({response}) => {
                    this.$refs.form.setErrors(response.data.errors);
                }).finally(() => {
                    this.$store.commit('setLoading', false);
                })
            },
            close() {
                Object.assign(this.$data, this.$options.data());
                this.$refs.form.reset();
                this.dialog = false;
            }
        }
    }
</script>

<style scoped>

</style>
